import { WifiOff } from "lucide-react";
import { useSyncExternalStore } from "react";
import { useTranslation } from "react-i18next";

function subscribe(onChange: () => void) {
  window.addEventListener("online", onChange);
  window.addEventListener("offline", onChange);
  return () => {
    window.removeEventListener("online", onChange);
    window.removeEventListener("offline", onChange);
  };
}

export function useOnline(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => navigator.onLine,
    () => true,
  );
}

/** Yellow bar while the device is offline (T11-06); forms keep their drafts meanwhile (T11-04). */
export function OfflineBanner() {
  const { t } = useTranslation();
  const online = useOnline();
  if (online) {
    return null;
  }
  return (
    <div
      role="status"
      data-slot="offline-banner"
      className="flex items-center gap-2 border-b border-[#b45309] bg-[#fef3c7] px-4 py-2 text-sm font-medium text-[#78350f]"
    >
      <WifiOff className="size-4 shrink-0" aria-hidden />
      {t("offline.banner")}
    </div>
  );
}
